module.exports = __webpack_public_path__ + "img/about_img4.835edc0f.png";